import { Controller } from '@hotwired/stimulus'

const STORAGE_KEY = 'collapsedSections'
const COLLAPSED_CLASS = 'section-card--collapsed'

export default class extends Controller {
  static targets = ['caret', 'body']
  static values = { key: String }

  connect () {
    const collapsed = this.readState().includes(this.storageKey())
    this.apply(collapsed)
    this.element.setAttribute('data-csi-ready', 'true')

    this.boundHandleSetAll = this.handleSetAll.bind(this)
    window.addEventListener('collapsible-sections:set-all', this.boundHandleSetAll)
  }

  disconnect () {
    window.removeEventListener('collapsible-sections:set-all', this.boundHandleSetAll)
  }

  toggle () {
    const collapsed = !this.element.classList.contains(COLLAPSED_CLASS)
    this.apply(collapsed)
    this.writeState(collapsed)
    window.dispatchEvent(new CustomEvent('collapsible-section:changed'))
  }

  handleSetAll (event) {
    this.apply(event.detail.collapsed)
  }

  apply (collapsed) {
    this.element.classList.toggle(COLLAPSED_CLASS, collapsed)
    if (this.hasCaretTarget) {
      this.caretTarget.setAttribute('aria-expanded', String(!collapsed))
    }
  }

  storageKey () {
    return window.location.pathname + ':' + this.keyValue
  }

  readState () {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]')
    } catch {
      return []
    }
  }

  writeState (collapsed) {
    const set = new Set(this.readState())
    if (collapsed) {
      set.add(this.storageKey())
    } else {
      set.delete(this.storageKey())
    }
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify([...set]))
    } catch {
      // localStorage unavailable; ignore
    }
  }
}
